var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inputText',{attrs:{"data":_vm.data.button,"label":_vm.$t('design.info.button.text'),"callback":function(value) {
        _vm.setValue(value);
      },"error":false,"styling":{ input: 'width: 100%; display: block' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }